import { Pipe, PipeTransform } from '@angular/core';
import { prettyDateTime } from '../utils/helpers';

@Pipe({
    name: 'prettyDateTime',
    standalone: false
})
export class PrettyDateTimePipe implements PipeTransform {

  transform(value?: string | Date | moment.Moment/* , ...args: unknown[] */): string | null {
    if (!value) return null;
    return prettyDateTime(value);
  }

}
